import { NgModule } from '@angular/core';
import { PxPipe } from '@shared/pipes/px/px.pipe';

@NgModule({
  declarations: [PxPipe],
  exports: [PxPipe]
})
export class PxModule {}
